module.exports = ".highlighted {\n  background-color: darkgrey; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/character/character-sheet/character-sheet-mechanics/stat-grid/stat-grid.component.scss
// module id = ./src/app/character/character-sheet/character-sheet-mechanics/stat-grid/stat-grid.component.scss
// module chunks = main